import {
  get,
  post,
  patch,
  put,
  del,
} from '@/utils/request';

const url = 'card-add-applies';

// 获取办卡申请列表
export function index(data) {
  return get({
    url,
    data,
  });
}

// 获取某个办卡申请详情
export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

// 保存某个办卡申请
export function store(data) {
  return post({
    url,
    data,
  });
}

// 保存某个办卡申请
export function restore(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

// 通过某个办卡申请
export function pass(id, data) {
  return post({
    url: `${url}/${id}`,
    data,
  });
}

// 驳回某个办卡申请
export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

// 撤回某个办卡申请
export function destroy(id, update_time) {
  return del({
    url: `${url}/${id}`,
    data: { update_time },
  });
}
